
const Logo = () => {


    return (<div className="w-screen h-screen flex bg-white">
        <img className='w-screen self-center flex-none' alt="" src='https://res.cloudinary.com/dtunq4piy/image/upload/c_scale,w_1500/f_auto/dpr_2.0/v1654715228/moscowcycle/landing/019_%D0%A4%D0%98%D0%9D%D0%98%D0%A8_%D0%9B%D0%9E%D0%93%D0%9E.jpeg' /></div>)
}
export default Logo;